import { Configuration, RedirectRequest } from "@azure/msal-browser";

const isProd = process.env.REACT_APP_ENVIRONMENT === "production";

// localStorage = session partagée entre onglets (prod uniquement)
// sessionStorage = session isolée par onglet (recette + localhost)
const useSharedSession = isProd;

// Frontend Client IDs
const CLIENT_ID_PROD = "c3e6bee6-cbe7-4c35-b532-fe5517b02a86";
const CLIENT_ID_RECETTE = "a89c4fc2-7595-4884-a304-be45e4aa0da9";

// API Scopes
const API_SCOPE_PROD = "api://zoulloo-api-prod/access_as_user";
const API_SCOPE_RECETTE = "api://zoulloo-api-recette/access_as_user";

export const msalConfig: Configuration = {
	auth: {
		clientId: isProd ? CLIENT_ID_PROD : CLIENT_ID_RECETTE,
		authority: "https://zoullooauth.ciamlogin.com/",
		knownAuthorities: ["zoullooauth.ciamlogin.com"],
		redirectUri: "/",
		postLogoutRedirectUri: "/",
		navigateToLoginRequestUrl: true
	},
	cache: {
		// localStorage = session partagée entre onglets (prod)
		// sessionStorage = session isolée par onglet (recette + localhost)
		cacheLocation: useSharedSession ? "localStorage" : "sessionStorage",
		storeAuthStateInCookie: false
	}
};

export const loginRequest: RedirectRequest = {
	scopes: [
		"openid",
		"email",
		"profile",
		"offline_access",
		isProd ? API_SCOPE_PROD : API_SCOPE_RECETTE
	]
};
